import { LandingNavbar } from "../components/Homepage/landing-navbar"
import News from "../components/News"

const NewsPage = () => {
    return (
    <main className="h-full bg-[#111827] overflow-auto">
        <div className="mx-auto max-w-screen-xl h-full w-full">
            <LandingNavbar />
            <News />
        </div>
      </main>
    )
}

export default NewsPage